<template>
    <el-menu class="header" :default-active="$route.path" mode="horizontal" @select="handleSelect" text-color="rgba(0,0,0,0.85)" active-text-color="#3361FF">
        <title>多盟轻推送-开发者平台</title>
        <div class="logo">
            <a href="/abroad">
                <img v-if="language == 'English'" src="@/assets/img/abroad_logo_en.png.png">
                <img v-else src="@/assets/img/abroad_logo_cn.png.png">
            </a>
        </div>
        <div class="topnav">
            <div class="menu">
                <el-menu-item index="/abroad/app/list" :disabled="isOverseasNewUser">{{$t('menu.media')}}</el-menu-item>
                <el-menu-item index="/abroad/stats/info" :disabled="isOverseasNewUser">{{$t('menu.data')}}</el-menu-item>
                <el-menu-item index="/abroad/doc/sdkWord" :disabled="isOverseasNewUser">{{$t('menu.docking')}}</el-menu-item>
                <el-menu-item index="/abroad/account/companyInfo">{{$t('menu.Account')}}</el-menu-item>
            </div>
            <div class="header-right">
                <div class="header-user-con">
                    <el-dropdown class="lang" trigger="click" @command="langChange">
                        <span class="el-dropdown-link">
                            {{language}} <i class="el-icon-arrow-down"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item divided  command="zh">中文</el-dropdown-item>
                            <el-dropdown-item divided  command="en">English</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <div class="user-name">
                        <!-- <div style="color: rgba(0,0,0,0.85); display: flex;"> -->
                            <el-dropdown @command="handleCommand" style="line-height: 75px;">
                                <span class="el-dropdown-link">
                                    <Icon name="user" class="svg-icon userIcon"/>
                                    <span>
                                        {{username}} <i class="el-icon-arrow-down" style="margin-left: 6px"></i>
                                    </span>
                                </span>
                                <el-dropdown-menu slot="dropdown" class="custom-dropdown-width">
                                    <el-dropdown-item divided  command="reset">{{$t("login.forget")}}</el-dropdown-item>
                                    <el-dropdown-item divided  command="logout">{{$t('logout')}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        <!-- </div> -->
                        <!-- <p style="color: rgba(0,0,0,0.85)">{{$t('menu.operator')}}{{operatorname}}</p> -->
                    </div>
                </div>
            </div>
        </div>
    </el-menu>
</template>
<script>
import util from '@/utils/util'
    export default {
        data() {
            return {
                path:'',
                collapse: false,
                fullscreen: false,
                name: '多盟轻推',
                language: '中文',
                isOverseasNewUser: false
            }
        },
        computed:{
            username(){
                let user = JSON.parse(util.getCookie("user"))
                return user ? user.email: ""
            },
            operatorname(){
                let user = JSON.parse(util.getCookie("user"))
                return user ? user.operatorEmail: ""
            }
        },
        created(){
            this.path = this.$route.path;
            var lang = localStorage.getItem("lang")
            if(lang == 'en') {
                this.language = 'English'
            } else if (lang == 'zh') {
                this.language = '中文'
            }
            this.updateUserStatus(); 
            this.$eventBus.$on('companyUpdated', this.updateUserStatus);
        },
        beforeDestroy() {
            this.$eventBus.$off('companyUpdated', this.updateUserStatus);
        },
        methods:{
            // 中英文切换
            langChange(command) {
                this.$i18n.locale = command
                localStorage.setItem("lang", command)
                if(command == 'en') {
                    this.language = 'English'
                } else if (command == 'zh') {
                    this.language = '中文'
                }
                this.$eventBus.$emit("getLang",command)
            },
            handleCommand(command) {
                if(command == 'logout') {
                    // 清楚cookie，到登录页
                    util.delCookie("token");
                    util.delCookie("user");
                    window.location.href = '/#/login';
                } else if (command == 'reset') {
                    this.$router.push('/reset');
                }
            },
           handleSelect(key, keyPath) {
                return this.$router.push(key)
           },
           updateUserStatus() {
                const userStr = util.getCookie("user")
                if (!userStr) {
                    this.isOverseasNewUser = false
                    return
                }
                const user = JSON.parse(userStr)
                this.isOverseasNewUser = user.verify_code === 0 && !user.old_user 
            }
        }
    }
</script>
<style lang="scss" scoped>
    .header {
        position: relative;
        width: 100%;
        font-size: 22px;
        color: #000;
        border-bottom:  1px solid #EBEBEB;
        display: flex;
        justify-self: flex-start;
    }
    .collapse-btn{
        float: left;
        padding: 0 21px;
        cursor: pointer;
        line-height: 60px;
    }
    .header .logo {
        width: 260px;
        line-height: 64px;
        margin-left: 24px;
    }
    .header .logo a{
        color: #fff;
        width: 100%;
        /* float: left; */
        img{
            height: 30px;
        }
    }
    .topnav {
        display: flex;
        justify-content: space-between;
        margin-left: 46px;
        width: 100%;
        padding-right: 24px;
    }
    .menu {
        height: 64px;
        display: flex;
        // overflow: hidden;
    }
    .menu .el-menu-item {
        height: 64px;
        line-height: 64px;
        padding: 0;
        margin: 0 18px;
    }
    .el-menu-item:focus, .el-menu-item:hover {
        background-color: transparent;
    }
    .header-right .doc-download{
        color:#000;
        font-size: 14px;
        padding: 0 20px;
        cursor: pointer;
    }
    .header-user-con{
        display: flex;
        height: 64px;
        align-items: center;
    }
    .header-user-con .lang{
        width: 67px;
        text-align: right;
    }
    .header-user-con .logout {
        margin: 0 10px;
        font-size: 26px;
        font-weight: 700;
    }
    .header-user-con .logout:hover {
        color: #20a0ff;
    }
    .userIcon.icon {
        width: 20px;
        height: 20px;
        margin-right: 12px;
    }
    .btn-fullscreen{
        transform: rotate(45deg);
        margin-right: 5px;
        font-size: 24px;
    }
    .btn-bell, .btn-fullscreen{
        position: relative;
        width: 30px;
        height: 30px;
        text-align: center;
        border-radius: 15px;
        cursor: pointer;
    }
    .btn-bell-badge{
        position: absolute;
        right: 0;
        top: -2px;
        width: 8px;
        height: 8px;
        border-radius: 4px;
        background: #f56c6c;
        color: #fff;
    }
    .btn-bell .el-icon-bell{
        color: #fff;
    }
    .user-name{
        margin-left: 10px;
        font-size: 14px;
        padding: 0 16px;
    }
    .user-avator{
        margin-left: 20px;
    }
    .user-avator img{
        display: block;
        width:40px;
        height:40px;
        border-radius: 50%;
    }
    .user-name .el-dropdown-link{
        color: rgba(0,0,0,0.85);
        cursor: pointer;
        display: flex;
        align-items: center;
    }
    .el-dropdown-menu__item{
        text-align: center;
    }
    .el-menu-item.is-active {
        border-bottom: 2px solid #3361FF;
    }
    .custom-dropdown-width {
        min-width: 150px;
    }
</style>
